import React, { useState, useEffect, useContext } from "react";
import { Paper, Box, Typography, Stack, Divider } from "@mui/material";
import PersonAddAlt1RoundedIcon from "@mui/icons-material/PersonAddAlt1Rounded";
import { simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";
import { getNuevosClientesAsync } from "../../../api/Dashboard";
import { monoFont } from "../../../theme";

const NuevosClientes = ({ selectedSucursal }) => {
  const [datos, setDatos] = useState({ hoy: 0, semana: 0, mes: 0 });
  const { setIsLoading, setIsUnautorized } = useContext(DataContext);

  const token = getToken();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getNuevosClientesAsync(token, selectedSucursal);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setDatos(result.data.result);
    })();
  }, [selectedSucursal]);

  const stats = [
    { label: "Hoy", value: datos.hoy },
    { label: "Semana", value: datos.semana },
    { label: "Mes", value: datos.mes },
  ];

  return (
    <Paper sx={{ padding: "17px 18px", height: "100%" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "16px" }}>
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: "10px",
            backgroundColor: "info.light",
            color: "info.main",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <PersonAddAlt1RoundedIcon sx={{ fontSize: 20 }} />
        </Box>
        <Typography sx={{ fontSize: 12.5, fontWeight: 500, color: "text.secondary" }}>Nuevos clientes</Typography>
      </Box>
      <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
        {stats.map((s) => (
          <Box key={s.label} sx={{ flex: 1, textAlign: "center" }}>
            <Typography sx={{ fontFamily: monoFont, fontSize: 22, fontWeight: 600, color: "text.primary" }}>
              {s.value}
            </Typography>
            <Typography sx={{ fontSize: 11.5, color: "text.secondary", marginTop: "2px" }}>{s.label}</Typography>
          </Box>
        ))}
      </Stack>
    </Paper>
  );
};

export default NuevosClientes;
